import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  Button,
} from "@b2b/ui-components";
import { Save, Send } from "lucide-react";

interface QuoteSidebarProps {
  formData: Record<string, any>;
  navigate: (path: string) => void;
  onSubmit?: () => void;
  submitting?: boolean;
}

export const QuoteSidebar = ({ formData, navigate, onSubmit, submitting }: QuoteSidebarProps) => (
  <div className="space-y-6">
    {/* Quote Summary */}
    <Card>
      <CardHeader>
        <CardTitle>Quote Summary</CardTitle>
      </CardHeader>
      <CardContent className="space-y-3">
        <div className="flex justify-between">
          <span className="text-muted-foreground">Quantity:</span>
          <span className="font-medium">
            {formData.quantity || "0"} units
          </span>
        </div>
        <div className="flex justify-between">
          <span className="text-muted-foreground">Unit Price:</span>
          <span className="font-medium">
            ${formData.unitPrice || "0.00"}
          </span>
        </div>
        <div className="flex justify-between pt-2 border-t border-border">
          <span className="font-medium">Total Amount:</span>
          <span className="font-bold text-lg text-primary">
            ${formData.totalAmount || "0.00"}
          </span>
        </div>
      </CardContent>
    </Card>

    {/* Tips */}
    <Card>
      <CardHeader>
        <CardTitle>Quote Tips</CardTitle>
      </CardHeader>
      <CardContent className="space-y-2 text-sm text-muted-foreground">
        <p>• Provide competitive pricing to increase your chances</p>
        <p>• Include high-quality product images</p>
        <p>• Attach relevant certificates and brochures</p>
        <p>• Be specific about delivery times and terms</p>
        <p>• Respond quickly to buyer inquiries</p>
      </CardContent>
    </Card>

    <div className="space-y-3">
      <Button
        className="w-full"
        size="lg"
        variant="primary"
        onClick={onSubmit}
        disabled={submitting}
      >
        <Send className="h-4 w-4 mr-2" />
        {submitting ? "Submitting..." : "Submit Quote"}
      </Button>
      <Button variant="outline" className="w-full">
        <Save className="h-4 w-4 mr-2" />
        Save as Draft
      </Button>
    </div>
  </div>
);
